import './style.styl';
// import template from 'directives/fullScroll/template.html';
export default function($timeout) {
  'ngInject';
  return {
    restrict: 'A',
    link: function(scope, element) {
      $timeout(function() {
        element.slimscroll({
          height: '100%',
          railOpacity: 0.9
        });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/fullScroll/index.js